import type { EventHandler } from 'playcanvas';
import type {
  ViewerAnimState,
  ViewerAvatarState,
  ViewerNavigationMode,
} from '@mindcloudxai/shared';
import type { Global } from '../../submodules/supersplat-viewer/src/types';

export interface EventBridgeContext {
  global: Global;
  events: EventHandler;
  getAnimState: () => ViewerAnimState;
  getAvatarState: () => ViewerAvatarState;
  applyCanvasSize: () => void;
}

/** 内部状态事件 → Viewer 契约事件桥接。 */
export function bridgeViewerEvents(ctx: EventBridgeContext): void {
  const { events } = ctx.global;

  events.on('progress:changed', (progress: number) => {
    ctx.events.fire('progress', progress);
  });
  events.on('firstFrame', () => {
    ctx.events.fire('ready');
  });
  // performanceMode 切换时按新缩放重算画布分辨率（半分辨率 ↔ 全分辨率）
  events.on('performanceMode:changed', () => ctx.applyCanvasSize());
  events.on('cameraMode:changed', (value: string) => {
    ctx.events.fire('navigationMode:changed', value as ViewerNavigationMode);
    ctx.events.fire('anim:changed', ctx.getAnimState());
  });
  events.on('animationTime:changed', () => ctx.events.fire('anim:changed', ctx.getAnimState()));
  events.on('animationPaused:changed', () => ctx.events.fire('anim:changed', ctx.getAnimState()));
  events.on('animationDuration:changed', () => ctx.events.fire('anim:changed', ctx.getAnimState()));
  events.on('measure.active', (active: boolean) => {
    ctx.events.fire('measure:changed', active);
  });
  [
    'avatarEnabled:changed',
    'avatarAvailable:changed',
    'avatarLoading:changed',
    'avatarUrl:changed',
    'avatarStatus:changed',
    'avatarAnimations:changed',
    'avatarCurrentAnimation:changed',
    'avatarFollowCamera:changed',
  ].forEach((eventName) => {
    events.on(eventName, () => ctx.events.fire('avatar:changed', ctx.getAvatarState()));
  });
}
